const BuyMeACoffeeButton = () => {
  // Create a custom Buy Me a Coffee button that mirrors the info button position
  return (
    <a
      href="https://www.buymeacoffee.com/ABmyMix"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 12px',
        backgroundColor: 'transparent',
        color: '#A0ADB8', // gray.400
        textDecoration: 'none',
        borderRadius: '6px',
        fontSize: '14px',
        fontWeight: '500', // medium
        transition: 'all 0.2s ease',
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = '#ffa726'; // accent.400
        e.currentTarget.style.transform = 'translateY(-1px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = '#A0ADB8'; // gray.400
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <span style={{ fontSize: '28px' }}>☕</span>
    </a>
  );
};

export default BuyMeACoffeeButton; 